'use client';

import React from 'react';
import Image from 'next/image';

const HeroSection = (props) => {
  const { dict } = props;

  return (
    <section className='relative py-20 px-4'>
      {/* Background Elements */}
      <div className='absolute inset-0'>
        <div className='absolute top-[350px] left-[288px] w-[812px] h-[600px] bg-lime-300 rounded-full opacity-80 blur-3xl' />
      </div>

      <div className='relative max-w-7xl mx-auto text-center'>
        {/* Main Heading */}
        <h1 className='text-7xl font-oswald font-normal text-white mb-8 leading-[80px]'>
          Green Energy LV
          <br />
          {dict.heroTitle}
        </h1>

        {/* Subtitle */}
        <p
          className='text-2xl font-montserrat font-normal text-white mb-16 leading-[31px]'
          dangerouslySetInnerHTML={{ __html: dict.heroSubtitle }}
        />

        {/* Hero Images */}
        <div className='relative flex justify-center items-center space-x-8'>
          <div className='absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full h-[330px] bg-lime-400 rounded-[40px]' />
          <Image
            src='./images/img_kdaskasd.png'
            alt='Electronics showcase'
            width={782}
            height={471}
            className='relative z-10'
          />
          <Image
            src='./images/img_wajfz.png'
            alt='Device 1'
            width={253}
            height={308}
            className='absolute top-[166px] right-[230px] z-20'
          />
          <Image
            src='./images/img_98af.png'
            alt='Device 2'
            width={218}
            height={290}
            className='absolute top-[184px] left-[230px] z-20'
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
